import { useQuery } from "@apollo/client/react";

import { getFragmentData } from "@/generated/graphql";
import { GetUserFeelingsDocument, UserFeelingFragmentDoc } from "@/generated/graphql/graphql";

export function useUserFeelings({ skip }: { skip?: boolean | undefined }) {
  const { data } = useQuery(GetUserFeelingsDocument, { skip });
  return getFragmentData(UserFeelingFragmentDoc, data?.userFeelings || []);
}
